import {css} from 'lit'; export default css`img{display:block;height:var(--goto-spacing-06);width:auto}chameleon-goto-logo{--goto-icon-size:var(--goto-layout-05)}`;
    